export const decompressJSON = <T>(jsonString: string): T => {
	const jsonObject = JSON.parse(atob(jsonString));

	if (typeof jsonObject !== "object") {
		throw new Error("JSON parse did not return an object");
	}

	return jsonObject;
};
